<script>
export default {
    name: 'IconCreditCard',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-credit-card"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M56 24v20a4 4 0 01-4 4H12a4 4 0 01-4-4V24h48zM38 37H14v4h24v-4zm-14-7H14v4h10v-4zm28-14a4 4 0 014 4H8a4 4 0 014-4h40z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
